import * as React from 'react'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Typography from '@mui/material/Typography'
import Accordion from '@mui/material/Accordion'
import IntlMessages from '../../util/IntlMessages'
import Header from '../../components/header'
import { faq } from '../../constants/data'

export default function Faq() {

    const getariaControls = (index) => "panel" + index + "a-content"
    const getId = (index) => "panel" + index + "a-header"

    return (
        <React.Fragment>
            <Header title={<IntlMessages id="faq" />} />
            <br />
            {faq.map((obj, index) => (
                <Accordion key={index}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={() => getariaControls(index)}
                        id={() => getId(index)}
                    >
                        <Typography variant='h6'>{obj.question}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant='body1'>
                            {obj.answer}
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            ))}
        </React.Fragment>
    )
}